export const NatureOfTravel = {
    PRIVATE: 'PRIVATE',
    COMMERCIAL: 'COMMERCIAL'
}
